module.exports = __webpack_public_path__ + "static/media/mage.f3c96375.jpg";